/******
 * B1 Yönetim Sistemleri Yazılım ve Danışmanlık Limited Şirketi
 * B1 Digitial
 * http://www.b1.com.tr
 *
 * chat-records-on-request.model Information
 *
 *
 * Date      : 26.02.2020
 * Time      : 14:47
 * Developer : ibrahimcobani
 *
 *******/
export class ChatRecordsOnRequestModel {
  id: number;
  hotel_id: number;
  request_header_id: number;
  user_type: string;
  user_id: number;
  user_name: string;
  avatar_url: string;
  message_type: string;
  message: string;
  read: boolean;
  read_at: Date;
  created_at: Date;

  auto_translate: boolean;
  to_lang: string;
  from_lang: string;
  record_type: 'HotSupport' | '';

  constructor(
    id: number,
    hotel_id: number,
    request_header_id: number,
    user_type: string,
    user_id: number,
    user_name: string,
    avatar_url: string,
    message_type: string,
    message: string,
    read: boolean,
    read_at: Date,
    created_at: Date,
  ) {
    this.id = id;
    this.hotel_id = hotel_id;
    this.request_header_id = request_header_id;
    this.user_type = user_type;
    this.user_id = user_id;
    this.user_name = user_name;
    this.avatar_url = avatar_url;
    this.message_type = message_type;
    this.message = message;
    this.read = read;
    this.read_at = read_at;
    this.created_at = created_at;
    this.record_type = '';
  }
}
